import React from 'react';
import { Search } from 'lucide-react';

/**
 * SupervisionFilters — search + filter pills + sort dropdown +
 * establishment filter for GlobalSupervisionTab.
 * Pure presentational. Extracted 29/05/2026.
 */
export default function SupervisionFilters({
  search, setSearch,
  filter, setFilter,
  sortBy, setSortBy,
  establishmentFilter, setEstablishmentFilter,
  establishmentOptions,
  filters,
  sorts,
}) {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      <div className="flex-1 min-w-[200px] relative">
        <Search className="w-3.5 h-3.5 absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Filtrer par nom, clé, société, cohorte..."
          className="w-full bg-background text-slate-100 placeholder-slate-600 border border-ink-600 rounded-md pl-9 pr-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-400"
          data-testid="global-search"
        />
      </div>
      <div className="flex items-center gap-1 flex-wrap">
        {filters.map(f => {
          const Icon = f.icon;
          const active = filter === f.id;
          return (
            <button
              key={f.id}
              onClick={() => setFilter(f.id)}
              className={`flex items-center gap-1 text-xs px-2.5 py-1.5 rounded-md border transition-colors ${
                active
                  ? 'bg-purple-500/15 border-purple-400 text-purple-300 font-semibold'
                  : 'bg-background border-ink-600 text-slate-400 hover:text-slate-200'
              }`}
              data-testid={`filter-${f.id}`}
            >
              <Icon className="w-3 h-3" /> {f.label}
            </button>
          );
        })}
      </div>
      <select
        value={sortBy}
        onChange={(e) => setSortBy(e.target.value)}
        className="bg-background text-slate-100 border border-ink-600 rounded-md px-2 py-1.5 text-xs focus:outline-none focus:ring-2 focus:ring-purple-400"
        data-testid="global-sort"
      >
        {sorts.map(s => <option key={s.id} value={s.id}>Tri : {s.label}</option>)}
      </select>
      <select
        value={establishmentFilter}
        onChange={(e) => setEstablishmentFilter(e.target.value)}
        className="bg-background text-slate-100 border border-ink-600 rounded-md px-2 py-1.5 text-xs focus:outline-none focus:ring-2 focus:ring-emerald-400"
        data-testid="global-establishment-filter"
      >
        <option value="__all__">Établissement : tous</option>
        <option value="__none__">— Sans établissement —</option>
        {establishmentOptions.map(e => (
          <option key={e} value={e}>{e}</option>
        ))}
      </select>
    </div>
  );
}
